import { useBlocNext } from "@blac/react";
import styled from "@emotion/styled";
import { IonContent } from "@ionic/react";
import type { FC, ReactElement, ReactNode, HTMLAttributes } from "react";
import {
  APP_BREAKPOINT,
  APP_BREAKPOINT_SM,
  APP_CONTENT_WIDTH
} from "src/constants/layout";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";

export const AnimatedPageWrapper = styled.main`
  label: AnimatedPage;
  min-width: min(100%, ${APP_CONTENT_WIDTH}px);
  width: min(100%, ${APP_CONTENT_WIDTH}px);
  min-height: 100%;
  margin: 0 auto;
  display: block;
  flex: 1;
  --extra-top: 0px;
  --extra-bottom: 0px;
  --padding-top: calc(var(--app-top, 0px) + var(--extra-top));
  --padding-bottom: calc(var(--app-bottom, 0px) + var(--extra-bottom));

  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);
  padding-left: var(--space-md);
  padding-right: var(--space-md);

  &[data-flex="true"] {
    display: flex;
  }

  &[data-space="top"],
  &[data-space="both"] {
    --extra-top: 1.4rem;
  }

  &[data-space="bottom"],
  &[data-space="both"] {
    --extra-bottom: 1.4rem;
  }

  &[data-disable-safe-area-top="true"] {
    @media (max-width: ${APP_BREAKPOINT - 1}px) {
      --padding-top: calc(var(--extra-top, 0px) + var(--tab-nav-height, 0px));
    }
  }
`;

const IonContentStyled = styled(IonContent)`
  background-color: var(--color-cream);
`;

interface AnimatedPageProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode | undefined;
  flex?: boolean;
  spaceY?: "none" | "top" | "bottom" | "both";
  disableSafeAreaTop?: boolean;
}

/**
 * Base Page component that animates when it enters/exits from route change
 */
const AnimatedPage: FC<AnimatedPageProps> = ({
  children,
  flex = false,
  spaceY: space = "none",
  disableSafeAreaTop = false,
  ...props
}): ReactElement => {
  const [{ allowIonContentScrollY }] = useBlocNext(AppViewCubit);

  return (
    <IonContentStyled
      id={"ion-c"}
      scrollEvents
      scrollY={allowIonContentScrollY}
    >
      <AnimatedPageWrapper
        {...props}
        data-flex={String(flex)}
        data-space={space}
        data-disable-safe-area-top={String(disableSafeAreaTop)}
      >
        {children}
      </AnimatedPageWrapper>
    </IonContentStyled>
  );
};

export default AnimatedPage;
